// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"532":"a7dbde30","632":"52981d65"}[chunkId] + ".css";
};